import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from '../src/components/vue-baidu-map/components'
//import BaiduMap from 'vue-baidu-map'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as echarts from 'echarts'
import scroll from 'vue-seamless-scroll'

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import App from './App'
import router from './router'

import store from './store'
Vue.use(BaiduMap, {
  ak: '0b5dnkn9rQ0Z4KzZNqWY2rY7XZQOjqEP'
})

Vue.use(VueDirectiveImagePreviewer)
Vue.use(scroll)

//Vue.component('bml-marker-cluster', BmlMarkerClusterer)


Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios


Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueAxios, axios);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js